import i18next from "i18next";
import es from "./platforms.es.json";
import en from "./platforms.en.json";

// Textos de «Pago de plataformas» (#956 / #957) en su propio namespace, para
// no crecer el `common` compartido. Se registra al importar la sección (o en
// cuanto i18next termine de iniciar, si todavía no lo hizo).
export const PLATFORMS_NS = "expensesPlatforms";

function register() {
  if (i18next.hasResourceBundle("es", PLATFORMS_NS)) return;
  i18next.addResourceBundle("es", PLATFORMS_NS, es, true, true);
  i18next.addResourceBundle("en", PLATFORMS_NS, en, true, true);
}

if (typeof i18next.on === "function") {
  if (i18next.isInitialized) register();
  else i18next.on("initialized", register);
}
